export const formatWithCommas = (value: string) => {
  const sanitizedValue = value.replace(/[^0-9]/g, '');
  return sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatToNaira = (amount?: number): string => {
  if (!amount) return '₦0.00';
  return `₦${amount?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
};

export const formatNumber = (value: number): string => {
  if (value >= 1_000_000) {
    return (value / 1_000_000).toFixed(1) + 'm';
  } else if (value >= 1_000) {
    return (value / 1_000).toFixed(1) + 'k';
  } else {
    return value.toString();
  }
};
export const formatPhoneNumber = (phoneNumber: string): string => {
  if (phoneNumber.startsWith('234') && phoneNumber.length === 13) {
    return phoneNumber.replace(/^234/, '0');
  }
  return phoneNumber;
};
